import { GlobalSearchConstants } from "constants/Actions";
import { IAPIActionBase, IMainSearchAction } from "us.common/interfaces";

export const GlobalSearchActions: Readonly<IAPIActionBase & IMainSearchAction> =
  {
    all: {
      search: (data) => ({
        type: GlobalSearchConstants.GET_ALL_GLOBAL_SEARCH_DATA,
        payload: {
          data: data,
          isLoading: true,
        },
      }),
      success: (data) => ({
        type: GlobalSearchConstants.GET_ALL_GLOBAL_SEARCH_DATA_SUCCESS,
        payload: {
          data: data,
          isLoading: false,
        },
      }),
      fail: (error) => ({
        type: GlobalSearchConstants.GET_ALL_GLOBAL_SEARCH_DATA_FAIL,
        payload: {
          error: error,
          isLoading: false,
        },
      }),
      set: (data) => ({
        type: GlobalSearchConstants.GLOBAL_BROWSER_BACK_NAVIGATION,
        payload: {
          data: data,
          isLoading: true,
        },
      }),
      updateViewedList: (data) => ({
        type: GlobalSearchConstants.UPDATE_VIEWED_GLOBAL_LIST,
        payload: {
          data: data,
          isLoading: false,
        },
      }),
    },
    invoiceRef: {
      search: (data) => ({
        type: GlobalSearchConstants.GET_INVOICE_REF_GLOBAL_SEARCH_DATA,
        payload: {
          data: data,
          isLoading: true,
        },
      }),
      success: (data) => ({
        type: GlobalSearchConstants.GET_INVOICE_REF_GLOBAL_SEARCH_DATA_SUCCESS,
        payload: {
          data: data,
          isLoading: false,
        },
      }),
      fail: (error) => ({
        type: GlobalSearchConstants.GET_INVOICE_REF_GLOBAL_SEARCH_DATA_FAIL,
        payload: {
          error: error,
          isLoading: false,
        },
      }),
    },
    invoice: {
      search: (data) => ({
        type: GlobalSearchConstants.GET_INVOICE_GLOBAL_SEARCH_DATA,
        payload: {
          data: data,
          isLoading: true,
        },
      }),
      success: (data) => ({
        type: GlobalSearchConstants.GET_INVOICE_GLOBAL_SEARCH_DATA_SUCCESS,
        payload: {
          data: data,
          isLoading: false,
        },
      }),
      fail: (error) => ({
        type: GlobalSearchConstants.GET_INVOICE_GLOBAL_SEARCH_DATA_FAIL,
        payload: {
          error: error,
          isLoading: false,
        },
      }),
    },
    case: {
      search: (data) => ({
        type: GlobalSearchConstants.GET_CASE_GLOBAL_SEARCH_DATA,
        payload: {
          data: data,
          isLoading: true,
        },
      }),
      success: (data) => ({
        type: GlobalSearchConstants.GET_CASE_GLOBAL_SEARCH_DATA_SUCCESS,
        payload: {
          data: data,
          isLoading: false,
        },
      }),
      fail: (error) => ({
        type: GlobalSearchConstants.GET_CASE_GLOBAL_SEARCH_DATA_FAIL,
        payload: {
          error: error,
          isLoading: false,
        },
      }),
    },
    debtor: {
      search: (data) => ({
        type: GlobalSearchConstants.GET_DEBTOR_GLOBAL_SEARCH_DATA,
        payload: {
          data: data,
          isLoading: true,
        },
      }),
      success: (data) => ({
        type: GlobalSearchConstants.GET_DEBTOR_GLOBAL_SEARCH_DATA_SUCCESS,
        payload: {
          data: data,
          isLoading: false,
        },
      }),
      fail: (error) => ({
        type: GlobalSearchConstants.GET_DEBTOR_GLOBAL_SEARCH_DATA_FAIL,
        payload: {
          error: error,
          isLoading: false,
        },
      }),
      updateData: (data) => ({
        type: GlobalSearchConstants.TOGGLE_GLOBAL_DEBTOR_AR,
        payload: {
          data: data,
          isLoading: false,
        },
      }),
    },
    creditor: {
      search: (data) => ({
        type: GlobalSearchConstants.GET_CREDITOR_GLOBAL_SEARCH_DATA,
        payload: {
          data: data,
          isLoading: true,
        },
      }),
      success: (data) => ({
        type: GlobalSearchConstants.GET_CREDITOR_GLOBAL_SEARCH_DATA_SUCCESS,
        payload: {
          data: data,
          isLoading: false,
        },
      }),
      fail: (error) => ({
        type: GlobalSearchConstants.GET_CREDITOR_GLOBAL_SEARCH_DATA_FAIL,
        payload: {
          error: error,
          isLoading: false,
        },
      }),
      updateData: (data) => ({
        type: GlobalSearchConstants.TOGGLE_GLOBAL_CREDITOR_GROUP,
        payload: {
          data: data,
          isLoading: false,
        },
      }),
    },
    history: {
      get: () => ({
        type: GlobalSearchConstants.GET_GLOBAL_SEARCH_HISTORY,
        payload: {
          data: {},
          isLoading: true,
        },
      }),
      save: (data) => ({
        type: GlobalSearchConstants.SAVE_GLOBAL_SEARCH_HISTORY,
        payload: {
          data: data,
          isLoading: true,
        },
      }),
      success: (data) => ({
        type: GlobalSearchConstants.GET_GLOBAL_SEARCH_HISTORY_SUCCESS,
        payload: {
          data: data,
          isLoading: false,
        },
      }),
      fail: (error) => ({
        type: GlobalSearchConstants.GET_GLOBAL_SEARCH_HISTORY_FAIL,
        payload: {
          error: error,
          isLoading: false,
        },
      }),
    },
    archiveCases: {
      get: (data) => ({
        type: GlobalSearchConstants.GET_ARCHIVE_GLOBAL_SEARCH_DATA,
        payload: {
          data: data,
          isLoading: true,
        },
      }),
      success: (data) => ({
        type: GlobalSearchConstants.GET_ARCHIVE_GLOBAL_SEARCH_DATA_SUCCESS,
        payload: {
          data: data,
          isLoading: false,
        },
      }),
      fail: (error) => ({
        type: GlobalSearchConstants.GET_ARCHIVE_GLOBAL_SEARCH_DATA_FAIL,
        payload: {
          error: error,
          isLoading: false,
        },
      }),
    },
    archiveCaseDetails: {
      get: (data) => ({
        type: GlobalSearchConstants.GET_ARCHIVE_GLOBAL_CASE_DETAILS,
        payload: {
          data: data,
          isLoading: true,
        },
      }),
      success: (data) => ({
        type: GlobalSearchConstants.GET_ARCHIVE_GLOBAL_CASE_DETAILS_SUCCESS,
        payload: {
          data: data,
          isLoading: false,
        },
      }),
      fail: (error) => ({
        type: GlobalSearchConstants.GET_ARCHIVE_GLOBAL_CASE_DETAILS_FAIL,
        payload: {
          error: error,
          isLoading: false,
        },
      }),
    },
    companyConfig: {
      get: (data) => ({
        type: GlobalSearchConstants.GET_COMPANY_CONFIG,
        payload: {
          data: data,
          isLoading: true,
        },
      }),
      success: (data) => ({
        type: GlobalSearchConstants.GET_COMPANY_CONFIG_SUCCESS,
        payload: {
          data: data,
          isLoading: false,
        },
      }),
      fail: (error) => ({
        type: GlobalSearchConstants.GET_COMPANY_CONFIG_FAIL,
        payload: {
          error: error,
          isLoading: false,
        },
      }),
    },
  };
